import { render } from "./AuthLayout.vue?vue&type=template&id=22205846"
const script = {}

import exportComponent from "C:\\www\\RACE_PARTNER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__